import {IconSizeProps} from "./types";

export default function EVMDarkIcon({ size=40,...props}: IconSizeProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5956 14.6424L25.0599 7.49951L29.5242 14.6424H20.5956Z" fill="#6E6E6E"/>
        <path d="M11.667 14.6424L16.1313 7.49951L20.5956 14.6424H11.667Z" fill="#6E6E6E"/>
        <path d="M25.0597 7.50021L20.5954 14.6431L16.1311 7.50021H25.0597Z" fill="black"/>
        <path d="M20.5956 14.6423L16.1313 21.7852L11.667 14.6423H20.5956Z" fill="black"/>
        <path d="M20.5952 25.3567L16.1309 32.4995L11.6666 25.3567H20.5952Z" fill="#6E6E6E"/>
        <path d="M29.5243 25.3567L25.06 32.4995L20.5957 25.3567H29.5243Z" fill="#6E6E6E"/>
        <path d="M16.1315 32.5008L20.5958 25.3579L25.06 32.5008H16.1315Z" fill="black"/>
        <path d="M20.5956 25.3572L25.0599 18.2144L29.5242 25.3572H20.5956Z" fill="black"/>
    </svg>

}